import React from "react";
import Dashboard from "../components/Dashboard";
import RevenueTable from "../components/RevenueTable";

function RevenuePage({
  rows,
  onRowsChange,
  loading,
  error,
  userRole,
  onRefresh,
  isLocked = false,
}) {
  return (
    <div className="max-w-8xl mx-auto px-3 sm:px-4 py-4 sm:py-6">
      <Dashboard rows={rows} />
      {error && (
        <div className="mb-3 text-xs sm:text-sm text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2">
          {error}
        </div>
      )}
      {isLocked && (
        <div className="mb-3 text-xs sm:text-sm text-amber-600 bg-amber-50 border border-amber-100 rounded-md px-3 py-2">
          ⚠️ Bạn không thể chỉnh sửa tháng này do admin đã khóa.
        </div>
      )}
      <RevenueTable
        rows={rows}
        onRowsChange={onRowsChange}
        onRefresh={onRefresh}
        userRole={userRole}
        loading={loading}
        isLocked={isLocked}
      />
    </div>
  );
}

export default RevenuePage;

